import { render, staticRenderFns } from "./blockTime.vue?vue&type=template&id=172e24be&scoped=true&"
import script from "./blockTime.vue?vue&type=script&lang=js&"
export * from "./blockTime.vue?vue&type=script&lang=js&"
import style0 from "./blockTime.vue?vue&type=style&index=0&id=172e24be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e24be",
  null
  
)

export default component.exports